import {FormCheck} from "react-bootstrap";
import React, {Fragment, useState} from "react";
import {setFilter, deleteFilter} from '../../../actions/FilterActions'
import {connect} from "react-redux";
import {deletePreviousFilter, setPreviousFilter, clearPrevious, refreshFilters, clearFilters} from "../../../actions";
import {FormGroup, Input, Label} from "reactstrap";

const SubFilterItem = ({Filters: {active_filter, available_filters, previous_filter}, PlotData: {active_plot}, refreshFilters, clearPrevious, clearFilters, filter_id, subfilter, deletePreviousFilter, setFilter, deleteFilter, setPreviousFilter}) => {

    const addSubFilter = (id) => {
        setPreviousFilter({[active_plot]: filter_id}, id)
        refreshFilters()
    };
    const deleteSubFilter = (id) => {
        // Je�eli nie zostanie �aden filtr to w��czone zostaje brak filtr�w
        if (previous_filter.hasOwnProperty(active_plot) && Object.keys(previous_filter[active_plot]).length === 1) {
            deletePreviousFilter({[active_plot]: filter_id}, id,"subfilter17")
            refreshFilters()
            setPreviousFilter({[active_plot]: 2})
        } else {
            deletePreviousFilter({[active_plot]: filter_id}, id,"subfilter21")
            refreshFilters()
        }
    };

    return (
        previous_filter.hasOwnProperty(active_plot) && <Fragment>
            {Object.values(previous_filter[active_plot]).includes(subfilter[0]) ? <Fragment  >
                    <FormGroup check className='wskaznikiCheckBox'>
                        <Label for={subfilter[1]} check>
                            <Input type="checkbox" name={subfilter[1]} id={subfilter[1]}
                                   onChange={() => deleteSubFilter(subfilter[0])}
                                   checked={Object.values(previous_filter[active_plot]).includes(subfilter[0])}/>
                            <span className="form-check-sign"/>
                            {subfilter[1]}</Label>
                    </FormGroup>
                </Fragment> :
                <Fragment>
                    <FormGroup check  className='wskaznikiCheckBox'>
                        <Label for={subfilter[1]} check>
                            <Input type="checkbox" name={subfilter[1]} id={subfilter[1]}
                                   onChange={() => addSubFilter(subfilter[0])}
                                   checked={Object.values(previous_filter[active_plot]).includes(subfilter[0])}/>
                            <span className="form-check-sign"/>
                            {subfilter[1]}</Label>
                    </FormGroup>
                </Fragment>}
        </Fragment>
    );
};

const mapStateToProps = state => ({
    Filters: state.Filters,
    PlotData: state.PlotData,

});
export default connect(mapStateToProps, {
    refreshFilters,
    clearPrevious,
    clearFilters,
    deletePreviousFilter,
    setFilter,
    setPreviousFilter,
    deleteFilter
})(SubFilterItem)